import blackPoint from './black-point.svg';
import grayPoint from './gray-point.svg';

const images = { blackPoint, grayPoint };

export default images;
